import { Stack, type StackProps } from "@mui/material";
import { CbhIcon, Text } from "@src/appV2/redesign/system/ui-components";

export function InstantPayIndicator(props: StackProps) {
  const { sx, ...restProps } = props;
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={sx} {...restProps}>
      <CbhIcon type="bolt-filled" color={(theme) => theme.palette.instantPay?.text} size="small" />
      <Text color={(theme) => theme.palette.instantPay?.text}>InstantPay</Text>
    </Stack>
  );
}
